<template>
  <div v-if="organization" class="gp-content">
    <transition name="fade" mode="out-in">
      <router-view :organization="organization"></router-view>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'Organization',
  data() {
    return {
      organization: null,
    };
  },
  computed: { },
  async mounted() {
    this.organization = await this.$store.dispatch('admin/getOrganization', {
      uuid: this.$route.params.id,
    });
  },
};
</script>

<style lang="scss" scoped>
</style>
